"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationLegalAssistance = function IllustrationLegalAssistance() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "65",
    height: "65",
    fill: "none",
    viewBox: "0 0 65 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M7.737 52h50"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M24.737 49a2 2 0 012-2h12a2 2 0 012 2v3h-16v-3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.737 47V21M35.737 18h12M17.737 18h12"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "32.737",
    cy: "18",
    r: "3",
    stroke: "#6F558A",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M48.237 39a6.5 6.5 0 006.5-6.5h-13a6.5 6.5 0 006.5 6.5zM18.237 39a6.5 6.5 0 006.5-6.5h-13a6.5 6.5 0 006.5 6.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M54.737 32.5l-7-14.5-6 14.5M24.737 32.5l-7-14.5-6 14.5"
  }));
};

var _default = IllustrationLegalAssistance;
exports.default = _default;